export { ROLES as ROLES };
export { messageInterval as messageInterval };
export { sizeLimit as sizeLimit };
export { messageSizeLimit as messageSizeLimit };
export { videoSizeLimit as videoSizeLimit };
export { coinDecimal as coinDecimal };
export { fiatDecimal as fiatDecimal };
export { formatMinS as formatMinS };
export { dateFormat as dateFormat };
export { getFileType as getFileType };
export { setPagination as setPagination };
export { setQueryParams as setQueryParams };
export { showOnlyLastFiveChar as showOnlyLastFiveChar };
import moment from 'moment';

const ROLES = {
  MERCHANT: "MERCHANT",
  SUPER: "SUPER",
  ADMIN: "ADMIN",
  SUPPORT: "SUPPORT"
};
const messageInterval = 20;
const sizeLimit = 2;
const messageSizeLimit = 9;
const videoSizeLimit = 6;
const coinDecimal = 8;
const fiatDecimal = 2;
function formatMinS(min) {
  const minutes = parseInt(min);
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  const label = (hours > 0 ? hours + "hr " : "") + (hours > 0 ? remainingMinutes > 0 ? remainingMinutes + " mins" : "" : remainingMinutes >= 0 ? remainingMinutes + " mins" : "");
  return label;
}
function dateFormat(dateTime) {
  if (!dateTime) return "";
  const str = String(dateTime);
  if (moment(str, moment.ISO_8601, true).isValid()) {
    return moment(str).format("DD/MM/YYYY HH:mm");
  }
  const withZ = (str.endsWith("Z") || str.includes("+")) ? str : `${str}Z`;
  if (moment(withZ, moment.ISO_8601, true).isValid()) {
    return moment(withZ).format("DD/MM/YYYY HH:mm");
  }
  if (moment(dateTime).isValid()) {
    return moment(dateTime).format("DD/MM/YYYY HH:mm");
  }
  return "";
}
function getFileType(url) {
  const extension = url.split(".").pop(); // Get the file extension from the URL
  const extension1 = extension.split("?");
  const imageExtensions = ["png", "jpg", "jpeg", "gif", "bmp", "svg", "avif", "webp", "ico", "tif", "tiff"]; // List of image file extensions
  const videoExtensions = ["mp4", "avi", "mov", "wmv", "webm", "mkv", "flv", "3gp", "vob"]; // List of video file extensions
  const pdfExtensions = ["pdf"]; // List of PDF file extensions

  if (imageExtensions.includes(extension1[0])) {
    return "image";
  } else if (videoExtensions.includes(extension1[0])) {
    return "video";
  } else if (pdfExtensions.includes(extension1[0])) {
    return "pdf";
  } else {
    return "unknown"; // Unknown file type
  }
}
function setPagination(page) {
  this.$router.replace({
    name: this.$route.name,
    query: {
      ...this.$route.query,
      page
    }
  }).catch(err => {});
}
function setQueryParams(obj) {
  this.$router.replace({
    name: this.$route.name,
    query: {
      ...this.$route.query,
      ...obj
    }
  }).catch(err => {});
}
function showOnlyLastFiveChar(str) {
  if (str !== null && str !== undefined) {
    const s = String(str);
    if (!s.length) return '';
    if (s.length <= 12) return s;
    return s.substring(0, 5) + '...' + s.substring(s.length - 5);
  }
  return '';
}

export default { ROLES, messageInterval, sizeLimit, messageSizeLimit, videoSizeLimit, coinDecimal, fiatDecimal, formatMinS, dateFormat, getFileType, setPagination, setQueryParams, showOnlyLastFiveChar };
